function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7273 21.75H22.4415L15.2624 1.93617C15.1441 1.59019 14.92 1.28975 14.6215 1.07701C14.3231 0.864281 13.9652 0.749927 13.5981 0.75H11.0079C10.6409 0.749927 10.283 0.864281 9.98453 1.07701C9.68606 1.28975 9.46197 1.59019 9.34371 1.93617L2.16456 21.75H0.878788C0.645719 21.75 0.422196 21.8422 0.257391 22.0063C0.0925863 22.1704 0 22.3929 0 22.625L0 24.375C0 24.6071 0.0925863 24.8296 0.257391 24.9937C0.422196 25.1578 0.645719 25.25 0.878788 25.25H7.90909C8.14216 25.25 8.36568 25.1578 8.53049 24.9937C8.69529 24.8296 8.78788 24.6071 8.78788 24.375V22.625C8.78788 22.3929 8.69529 22.1704 8.53049 22.0063C8.36568 21.8422 8.14216 21.75 7.90909 21.75H6.83367L8.11341 18.25H16.4927L17.7724 21.75H16.697C16.4639 21.75 16.2404 21.8422 16.0756 22.0063C15.9108 22.1704 15.8182 22.3929 15.8182 22.625V24.375C15.8182 24.6071 15.9108 24.8296 16.0756 24.9937C16.2404 25.1578 16.4639 25.25 16.697 25.25H23.7273C23.9603 25.25 24.1839 25.1578 24.3487 24.9937C24.5135 24.8296 24.6061 24.6071 24.6061 24.375V22.625C24.6061 22.3929 24.5135 22.1704 24.3487 22.0063C24.1839 21.8422 23.9603 21.75 23.7273 21.75ZM9.71335 13.875L12.303 6.79352L14.8927 13.875H9.71335Z",
  fill: "#9B37FF"
});
function SvgAlpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.efcbad8dabce695889fe4043cf633bfb.svg";
export { ForwardRef as ReactComponent };